import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const radiusAndShadow: ThemeApp['appComponents']['radiusAndShadow'] = {
  boxShadow: themeUi.core.shadow.shadow4,
  backgroundColor: themeUi.semantic.color.background.secondary950
};
